'use strict';

var utilities_combineClasses = require('./combineClasses-5P8GTQkg.js');
var FieldContext = require('./FieldContext-DI94tJqT.js');

const useInputAccessibilityProps = ({ ariaDescribedBy, }) => {
    const inputContext = FieldContext.useFieldContext();
    return {
        id: inputContext?.inputId,
        'aria-describedby': utilities_combineClasses.combineNullableStrings(ariaDescribedBy, ...(inputContext?.descriptionIds ?? [])),
        'aria-invalid': inputContext?.status === 'error',
        // aria-errormessage is only valid when aria-invalid is set
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-errormessage
        'aria-errormessage': inputContext?.status === 'error'
            ? inputContext?.errorMessageIds.join(' ') || undefined
            : undefined,
    };
};

exports.useInputAccessibilityProps = useInputAccessibilityProps;
//# sourceMappingURL=useInputAccessibilityProps-uzRyF5PP.js.map
